import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService } from '../services';

@Injectable()
export class DebugInterceptor implements HttpInterceptor {
  private readonly contextService = inject(ContextService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.contextService.debug) {
      request = request.clone({ setHeaders: { ['X-Debug']: this.contextService.debug } });
    }
    return next.handle(request);
  }
}
